import { Avatar, makeStyles, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
import CardWithData from './CardWithData'
import SkeletonLoader from './SkeletonLoader'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    // boxShadow:'none'
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '20px',
    cursor: 'pointer',
  },

  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '43px',
  },

  title2: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    margin: 5,

    color: '#313131',
  },
  title3: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',

    color: '#313131',
    paddingBottom: '10px',
  },
  title4: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '9px',
  },
  image: {
    // borderRadius: '45%',
    // height: '9%',
    width: '45px',
    height: '45px',
  },
  underline: {
    borderTop: '1px solid  #CCCCCC',
  },
  drop: {
    width: '70px',
    backgroundColor: 'white',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
  srollbar: {
    height: '580px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      borderRadius: '2px',
    },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    //   webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'slategrey',
      // outline: '1px solid slategrey',
    },
  },
  absentEmployeesClass: {
    height: '100%',
  },
  root2: {
    height: '213px',
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
  },
  layout: {
    padding: '0px 14px 0px 4px',
  },
}))

export default function CardWithEmployeeList({ heading, data, employeeId }) {
  const classes = useStyles()

  return (
    <CardWithData margin heading={heading}>
      {data ? (
        data.map((item, index) => (
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                paddingBottom: '12px',
              }}
            >
              <div style={{ paddingTop: '10px' }}>
                {item[employeeId] ? (
                  <Avatar src={item[employeeId] && item[employeeId]?.profilePicture} className={classes.image} />
                ) : (
                  <Skeleton variant="circle" width="45px" />
                )}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  paddingLeft: '15px',
                  paddingTop: '4px',
                }}
              >
                <Typography className={classes.title2}>
                  {item[employeeId] ? item[employeeId]?.firstName : <Skeleton variant="text" width="100px" />}
                </Typography>

                {item.count ? (
                  <Typography style={{ marginLeft: '3px', fontSize: '12px' }}>
                    {item.count ? item.count : <Skeleton variant="text" width="100px" />}
                  </Typography>
                ) : (
                  <Typography style={{ marginLeft: '3px', fontSize: '12px' }}>
                    {item[employeeId] && item[employeeId].position ? (
                      item[employeeId].position.positionName
                    ) : (
                      <Skeleton variant="text" width="100px" />
                    )}
                  </Typography>
                )}
                {/* <Typography style={{ marginLeft: '3px', fontSize: '12px' }}>
                  {item[employeeId]  ? (
                    formatDate(item[employeeId].createdAt)
                  ) : (
                    <Skeleton variant="text" width="100px" />
                  )}
                </Typography> */}
              </div>
            </div>
            {data?.length - 1 === index ? null : (
              <div className={classes.underline} style={{ width: '100%', marginTop: '5px' }}></div>
            )}
          </div>
        ))
      ) : (
        <SkeletonLoader />
      )}
      {data?.length === 0 ? (
        <Typography className={classes.title4} style={{ paddingLeft: '20px' }}>
          {heading === 'Top Performer' ? 'No Top Performer Found' : 'No Absentees This Week'}
        </Typography>
      ) : null}
    </CardWithData>
  )
}
